import {
    Item,
    MetaAvailableDto,
    SearchApi
} from '@/api';
import { apiConfiguration } from '@/api/config';
import { SortOptions } from '@/types/API';

export const searchApi = new SearchApi(apiConfiguration);

export type MetaAvailableResponse = {
    category: MetaAvailableDto[];
    sub_category: MetaAvailableDto[];
    genres: MetaAvailableDto[];
    artists: MetaAvailableDto[];
    conditions: MetaAvailableDto[];
    partners: MetaAvailableDto[];
    collections: MetaAvailableDto[];
    offer_types: MetaAvailableDto[];
};

export type SearchResponse = Awaited<ReturnType<typeof searchApi.searchControllerSearch>> & { meta_available: MetaAvailableResponse };

export const searchQueryFn = async ({
    query,
    limit,
    offset,
    artists,
    genres,
    conditions,
    categories,
    subCategories,
    offerTypes,
    collections,
    partners,
    sortBy,
    isPreview
}: {
    query: string;
    limit: number;
    offset: number;
    artists: string[];
    offerTypes: string[];
    genres: string[];
    conditions: string[];
    collections: string[];
    categories: string[];
    partners: string[];
    subCategories: string[];
    sortBy?: SortOptions
    isPreview?: boolean
}) => {
    const searchOfferTypes = offerTypes.slice();
    if (searchOfferTypes.includes(`${Item.OfferTypeEnum.BuyNow}`)) {
        searchOfferTypes.push(`${Item.OfferTypeEnum.OfferInstant}`);
    }
    return searchApi.searchControllerSearch(
        offset,
        limit,
        query,
        artists.length > 0 ? artists : undefined,
        genres.length > 0 ? genres : undefined,
        categories.length > 0 ? categories : undefined,
        subCategories.length > 0 ? subCategories : undefined,
        conditions.length > 0 ? conditions : undefined,
        partners.length > 0 ? partners : undefined,
        collections.length > 0 ? collections : undefined,
        undefined,
        searchOfferTypes.length > 0 ? (searchOfferTypes as unknown as string[]) : undefined,
        undefined,
        sortBy,
        isPreview
    );
};
